(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["airnomad-ro"]) return;
  try {
    
(() => {
 function init(){
  const root=document.getElementById('airnomad-landing');
  if(!root || root.dataset.ready)return;
  root.dataset.ready='true';
  const cfg=JSON.parse(root.parentElement.querySelector('[data-airnomad-config]').textContent);
  const variants=cfg.variants;
  const ui=cfg.ui;
  const initial=variants.find(v=>v.available)||variants[0];
  const state={qty:1,ids:[initial.id],busy:false};
  const money=c=>new Intl.NumberFormat('ro-RO',{minimumFractionDigits:2,maximumFractionDigits:2}).format(c/100)+' RON';
  const total=()=>Math.round(state.ids.reduce((s,id)=>s+variants.find(v=>v.id===id).price,0)*(state.qty===3?.85:state.qty===2?.9:1));
  const names=()=>state.ids.map(id=>variants.find(v=>v.id===id).title).join(' + ');
  const error=root.querySelector('.an-error');
  function image(v){return v.featured_image?.src || root.querySelector('.js-main-image').src}
  function showImage(src,alt,dimensions){
   const el=root.querySelector('.js-main-image');el.src=src;el.alt=alt;
   root.querySelector('.main-photo').classList.toggle('show-dimensions',dimensions);
  }
  function update(){
   root.querySelectorAll('.js-bundle').forEach(b=>{
    const chosen=Number(b.dataset.qty)===state.qty;
    b.classList.toggle('active',chosen);b.setAttribute('aria-pressed',String(chosen));
    b.querySelector('.picked').textContent=chosen?ui.selected:'';
   });
   root.querySelector('.js-bundle-cta span').textContent=state.qty===1?ui.add_one:ui.add_many.replace('{quantity}',state.qty);
   root.querySelectorAll('.js-price').forEach(e=>e.textContent=money(total()));
   root.querySelector('.js-final-choice').textContent=names()+' · '+state.qty+' '+ui.quantity+' · '+money(total());
   root.querySelector('.js-sticky-choice').textContent=state.qty+' '+ui.quantity+' · '+names();
   root.querySelectorAll('.checkout').forEach(b=>b.disabled=state.busy||state.ids.some(id=>!variants.find(v=>v.id===id).available));
  }
  function slots(focusSlot,focusId){
   const target=root.querySelector('.js-color-slots');target.replaceChildren();
   state.ids.forEach((id,index)=>{
    const slot=document.createElement('div');slot.className='color-slot';
    const label=document.createElement('p');label.textContent=ui.rucsac+' '+(index+1)+': '+variants.find(v=>v.id===id).title;
    slot.append(label);
    const choices=document.createElement('div');choices.className='slot-options';
    choices.setAttribute('role','group');choices.setAttribute('aria-label',ui.rucsac+' '+(index+1));
    variants.forEach(v=>{
     const b=document.createElement('button');b.type='button';b.className='slot-color'+(v.id===id?' active':'');
     b.dataset.slot=index;b.dataset.variant=v.id;b.disabled=!v.available;
     b.setAttribute('aria-pressed',String(v.id===id));b.setAttribute('aria-label',v.title+(v.available?'':' — '+ui.sold_out));
     const img=document.createElement('img');img.src=image(v);img.alt='';img.width=70;img.height=70;img.loading='lazy';
     const name=document.createElement('span');name.textContent=v.title;b.append(img,name);
     b.addEventListener('click',()=>{
      if(state.busy)return; state.ids[index]=v.id;
      if(index===0){showImage(image(v),'AirNomad '+v.title,false);root.querySelector('.js-final-image').src=image(v)}
      slots(index,v.id);update();
     });
     choices.append(b);
    });
    slot.append(choices);target.append(slot);
   });
   if(focusId)target.querySelector('[data-slot="'+focusSlot+'"][data-variant="'+focusId+'"]')?.focus({preventScroll:true});
  }
  root.querySelectorAll('.js-bundle').forEach(b=>b.addEventListener('click',()=>{
   if(state.busy)return;
   state.qty=Number(b.dataset.qty);
   while(state.ids.length<state.qty)state.ids.push(state.ids[0]);
   state.ids=state.ids.slice(0,state.qty);slots();update();
  }));
  root.querySelectorAll('.js-thumb').forEach(b=>b.addEventListener('click',()=>{
   showImage(b.dataset.image,b.querySelector('img').alt,b.dataset.dimensions==='true');
   root.querySelectorAll('.js-thumb').forEach(t=>t.classList.toggle('active',t===b));
  }));
  async function add(event){
   event.preventDefault();if(state.busy)return;
   state.busy=true;error.hidden=true;update();
   root.querySelectorAll('.checkout').forEach(b=>b.setAttribute('aria-busy','true'));
   const button=event.currentTarget;const previous=button.innerHTML;button.textContent=ui.busy;
   const grouped=new Map();state.ids.forEach(id=>grouped.set(id,(grouped.get(id)||0)+1));
   let added=false;
   try{
    const response=await fetch(cfg.addUrl,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[...grouped].map(([id,quantity])=>({id,quantity})),sections:['mini-cart'],sections_url:window.location.pathname})});
    const result=await response.json();
    if(!response.ok || result.status)throw new Error(typeof result.description==='string'?result.description:ui.error);
    added=true;
    const drawer=document.getElementById('mini-cart');
    if(!drawer||!result.sections?.['mini-cart']){window.location.assign(cfg.cartUrl);return}
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{cart:result,openMiniCart:true,replacementDelay:0}}));
   }catch(e){
    if(added){window.location.assign(cfg.cartUrl);return}
    error.textContent=e.message||ui.error;error.hidden=false;error.scrollIntoView({block:'nearest'});
   }finally{
    state.busy=false;button.innerHTML=previous;
    root.querySelectorAll('.checkout').forEach(b=>b.removeAttribute('aria-busy'));update();
   }
  }
  root.querySelectorAll('.checkout').forEach(b=>b.addEventListener('click',add));
  slots();update();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
})();



  } catch(e) { console.error(e); }
})();
})();
